const custom = [
    {
        name: 'Democrat Party',
        short_names: ['democrat-party'],
        keywords: ['democrat','party'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509768/custom-emoji/democrat-party.png',
        custom: true,
    },
    {
        name: 'Republican Party',
        short_names: ['republican-party'],
        keywords: ['republican', 'party'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509799/custom-emoji/republican-party.png',
        custom: true,
    },
    {
        name: 'Bernie Sanders',
        short_names: ['bernie-sanders'],
        keywords: ['bernie', 'sanders'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509769/custom-emoji/bernie-sanders.png',
        custom: true,
    },
    {
        name: 'Vote',
        short_names: ['vote'],
        keywords: ['vote'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509815/custom-emoji/vote.png',
        custom: true,
    },
    {
        name: 'Protest',
        short_names: ['protest'],
        keywords: ['protest'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509792/custom-emoji/protest.png',
        custom: true,
    },
    {
        name: 'United States Flag',
        short_names: ['united-states-flag'],
        keywords: ['united', 'states', 'flag'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509812/custom-emoji/united-states-flag.png',
        custom: true,
    },
    {
        name: 'Peace',
        short_names: ['peace'],
        keywords: ['peace'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509783/custom-emoji/peace.png',
        custom: true,
    },
    {
        name: 'Sign Petition',
        short_names: ['sign-petition'],
        keywords: ['sign', 'petition'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509813/custom-emoji/sign-petition.png',
        custom: true,
    },
    {
        name: 'Rose Party',
        short_names: ['rose-party'],
        keywords: ['rose', 'party'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509805/custom-emoji/rose-party.png',
        custom: true,
    },
    {
        name: 'Bitcoin',
        short_names: ['bitcoin'],
        keywords: ['bitcoin'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509798/custom-emoji/bitcoin.png',
        custom: true,
    },
    {
        name: 'Donald Trump',
        short_names: ['donald-trump'],
        keywords: ['donald', 'trump'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509769/custom-emoji/donald-trump.png',
        custom: true,
    },
    {
        name: 'Dogecoin',
        short_names: ['dogecoin'],
        keywords: ['dogecoin'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509805/custom-emoji/dogecoin.png',
        custom: true,
    },
    {
        name: 'Veto',
        short_names: ['veto'],
        keywords: ['veto'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509812/custom-emoji/veto.png',
        custom: true,
    },
    {
        name: 'Rally',
        short_names: ['rally'],
        keywords: ['rally'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509792/custom-emoji/rally.png',
        custom: true,
    },
    {
        name: 'Green Party',
        short_names: ['green-party'],
        keywords: ['green', 'party'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509770/custom-emoji/green-party.png',
        custom: true,
    },
    {
        name: 'Endorse',
        short_names: ['endorse'],
        keywords: ['endorse'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509775/custom-emoji/endorse.png',
        custom: true,
    },
    {
        name: 'Libertarian',
        short_names: ['libertarian'],
        keywords: ['libertarian'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509782/custom-emoji/libertarian.png',
        custom: true,
    },
    {
        name: 'BLM',
        short_names: ['blm'],
        keywords: ['black', 'lives', 'matter'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509758/custom-emoji/blm.png',
        custom: true,
    },
    {
        name: 'Tank',
        short_names: ['tank'],
        keywords: ['tank'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509800/custom-emoji/tank.png',
        custom: true,
    },
    {
        name: 'Hillary Clinton',
        short_names: ['hillary-clinton'],
        keywords: ['hillary', 'clinton'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509791/custom-emoji/hillary-clinton.png',
        custom: true,
    },
    {
        name: 'Obama',
        short_names: ['obama'],
        keywords: ['obama'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1625509813/custom-emoji/obama.png',
        custom: true,
    },
    {
        name: 'Nancy Pelosi',
        short_names: ['nancy-pelosi'],
        keywords: ['nancy', 'pelosi'],
        imageUrl: 'https://res.cloudinary.com/crowdpac/image/upload/v1624567448/custom-emoji/nancy-pelosi.png',
        custom: true,
    },
]

export default custom;